const ItemListWrapper = () =>
  import(/* webpackChunkName: "dishes-list" */ './pages/item-list-wrapper')
const ItemSearchWrapper = () =>
  import(/* webpackChunkName: "dishes-search" */ './pages/item-search-wrapper')

export default [
  { path: '/item/list', component: ItemListWrapper },
  {
    path: '/item/search/list',
    component: ItemSearchWrapper,
    name: 'itemSearchList',
  },
  { path: '/item/soldout', component: ItemSearchWrapper },
]
